// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__agf7A","plus":"styles_plus__9FUji","key":"styles_key__0G2Fx"};